export const USER_SETTINGS_FORM = {
  settingForm: document.querySelector('#aafp_update-settings') as HTMLFormElement,
  settingFirstName: document.querySelector('#aafp_user-setting-first-name') as HTMLInputElement,
  settingLastName: document.querySelector('#aafp_user-setting-last-name') as HTMLInputElement,
  settingDisplayName: document.querySelector('#aafp_dropdown-button-user-name') as HTMLElement,
  settingEmail: document.querySelector('#aafp_user-setting-email') as HTMLInputElement,
  settingSubmit: document.querySelector('#aafp_user-setting-update') as HTMLInputElement
}
